/**
 * Money formatter for subscription `PriceSnapshot` amounts.
 *
 * `amountCents` is in the currency's smallest unit (cents for USD, yen for
 * JPY). Thin wrapper over the shared `formatMinorUnits` — the zero-decimal
 * table lives in `shared/lib/money.ts` (single source of truth).
 *
 * Side-effect free — unit-tested in `format-amount.test.ts`.
 */
import { formatMinorUnits } from "@/shared/lib/money";

export function formatAmount(amountCents: number, currency: string): string {
  return formatMinorUnits(amountCents, currency);
}
